import {Status, WorkflowFilter} from "./types";

/** Snapshot of dashboard filter values (matches state in PageAdminDashboard). */
export type DashboardFilterValues = {
  admissionStatus: Status;
  starFilterActive: boolean;
  workflowFilter: WorkflowFilter;
};

/** Which filter controls are rendered in the toolbar. */
export type DashboardFilterVisibility = {
  showStarFilter: boolean;
  showStatusFilter: boolean;
  showWorkflowFilter: boolean;
};

export type HasActiveDashboardFiltersInput = DashboardFilterValues &
  DashboardFilterVisibility;

/**
 * True when any **visible** filter differs from its default (same defaults as `clearFilters` in
 * PageAdminDashboard: star off, status/workflow `id === null`).
 *
 * Hidden filters (e.g. status in tile view) are ignored so "Clear Filters" only appears when the
 * user can see something non-default.
 */
export const hasActiveDashboardFilters = ({
  starFilterActive,
  admissionStatus,
  workflowFilter,
  showStarFilter,
  showStatusFilter,
  showWorkflowFilter,
}: HasActiveDashboardFiltersInput): boolean =>
  (showStarFilter && starFilterActive) ||
  (showStatusFilter && admissionStatus.id !== null) ||
  (showWorkflowFilter && workflowFilter.id !== null);
